// hCaptcha is a runtime switch shared with the CMS: the widget renders and a token is required
// only when the site key is configured. Strapi mirrors this with HCAPTCHA_SECRET (see
// startup-cms/config/policies/verify-captcha.js) — set both or neither.
// Must stay a direct `process.env.NEXT_PUBLIC_*` reference so Next.js can inline it at build time.
export const IS_CAPTCHA_ENABLED = Boolean(process.env.NEXT_PUBLIC_HCAPTCHA_SITEKEY);
